import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Text, Heading } from 'rebass';
import Modal from 'app/modal/v2';

// "Save your page(s) before moving on?" — shown by useUnsavedChangesGuard
// whenever the member tries to leave a page/step/route with unsaved layer
// moves or resizes still pending. See the design's LeavingBeforeSave panel.
const UnsavedChangesModal = ({ isSaving, error, onSave, onDiscard, onCancel }) => (
  <Modal onClose={onCancel} closeButton bg="white" maxWidth={420} p="28px 24px 24px">
    <Heading fontFamily="Bitter" fontWeight={400} fontSize="26px" color="#000" mb={3} pr={4}>
      Save your page(s) before moving on?
    </Heading>
    <Text fontFamily="Poppins" fontSize="16px" lineHeight="150%" color="#64748B" mb={4}>
      Your changes here will be lost if you don&rsquo;t save.
    </Text>
    {!!error && (
      <Text fontFamily="Poppins" fontSize="14px" color="red" mb={3}>
        {error}
      </Text>
    )}
    <Box>
      <Button
        type="button"
        variant="primary"
        width="100%"
        height={48}
        fontFamily="Poppins"
        fontWeight={500}
        fontSize="16px"
        mb={2}
        disabled={isSaving}
        onClick={onSave}
        css="border-radius: 23px;"
      >
        {isSaving ? 'Saving…' : 'Yes, save'}
      </Button>
      <Button
        type="button"
        variant="outline"
        width="100%"
        height={48}
        fontFamily="Poppins"
        fontWeight={600}
        fontSize="16px"
        color="#64748B"
        disabled={isSaving}
        onClick={onDiscard}
        css="border-radius: 23px; border: 1.5px solid #64748B;"
      >
        No, don&rsquo;t save
      </Button>
    </Box>
  </Modal>
);

UnsavedChangesModal.propTypes = {
  isSaving: PropTypes.bool,
  error: PropTypes.string,
  onSave: PropTypes.func.isRequired,
  onDiscard: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

UnsavedChangesModal.defaultProps = {
  isSaving: false,
  error: null,
};

export default UnsavedChangesModal;
